<template>
    <div class="render3d-wrap">
        <div id="renderer3d" ref="renderer3d"></div>
        <div class="tools-panel">
            <div class="btn-wrap" @click="enlarge">
                <img class="btn-tools btn-enlarge" src="@/assets/images/design/enlarge@2x.png" alt="">
                <p class="text">放大</p>
            </div>
            <div class="btn-wrap" @click="view_fabric(current_color.color_thumb ? current_color.color_thumb : current_color.color_value)">
                <img class="btn-tools btn-view-fabric" src="@/assets/images/design/view_fabrics@2x.png" alt="">
                <p class="text">查看面料</p>
            </div>
        </div>
    </div>

</template>

<script>
    import tools3d from "@/utils/3d_tools";
    import {mapState} from 'vuex'
    import * as THREE from 'three'
    import {OBJLoader} from 'three/examples/jsm/loaders/OBJLoader'
    import {GLTFLoader} from 'three/examples/jsm/loaders/GLTFLoader'
    import C from '@/utils/constant'
    export default {
        name: "GltfRenderer3D",
        props : ['model3d-list', 'main-fabric-image'],
        data() {
            return {
                map3d_material: new Map(),
                map3d_obj : new Map(),
                current3d_obj: {},
                main_fabric_texture: new THREE.Texture(),
                obj_loader : new OBJLoader(),
                gltf_loader: new GLTFLoader(),
                renderer: new THREE.WebGLRenderer({
                    antialias: true
                }),
                scene: new THREE.Scene(),
                camera: new THREE.PerspectiveCamera(C.CAMERA_FOV, 540 / 540, 1, 10000),
                clothes_model: new THREE.Group(),
                spot_light: new THREE.SpotLight(0xFFFFFF, 0.33),
                directional_light: new THREE.DirectionalLight(0xFFFFFF, 0.23),
                drag: false,
                u: 1,
                v: 1,
                is_show_fabric_modal: false,
                model_center: new THREE.Vector3(0, 350, 0)
            }
        },
        watch: {
            model3dList: function(newVal, oldVal) {
                if(!this.category.is_enable3d) {
                    return
                }
                for(let key in newVal) {
                    if(!this.current3d_obj.hasOwnProperty(key)) {
                        continue;
                    }
                    if(this.current3d_obj[key].option_name === newVal[key].option_name) {
                        continue
                    }
                    // 更新当前显示部件数组
                    this.current3d_obj = {
                        ...this.current3d_obj,
                        [key] : {
                            option_name: newVal[key].option_name, model_path: newVal[key].model_path
                        },
                    }

                    // 隐藏该部件其他选项3D模型
                    let current_part = this.map3d_obj.get(key)
                    current_part.forEach((object, index) => {
                        object.scene.visible = false
                        this.render();
                    })
                    if(current_part.get(newVal[key].option_name)) {
                        let temp = current_part.get(newVal[key].option_name)
                        temp.scene.visible = true
                        this.render();
                        continue;
                    }
                    if(!newVal[key].model_path) {
                        continue;
                    }
                    this.gltf_loader.load(newVal[key].model_path, (object) => {
                        object.scene.traverse((child) => {
                            if(child instanceof THREE.Mesh) {
                                let material = new THREE.MeshPhongMaterial({
                                    shininess: 0,
                                    side: THREE.DoubleSide,
                                    map:this.part_custom_material[key].is_custom ? this.part_custom_material[key].texture : this.main_fabric_texture
                                })
                                child.material = material;
                            }
                        })
                        // object.scale.x = object.scale.y = object.scale.z = this.ratio;
                        object.scene.name = newVal[key].option_name
                        this.clothes_model.add(object.scene)
                        this.render();

                        current_part.set(newVal[key].option_name, object)
                    })
                }
            },
            mainFabricImage: function(newVal, oldVal) {
                if(!this.category.is_enable3d) {
                    return
                }
                if(newVal.color.lustre == 1) {
                    this.spot_light.intensity = 0.23
                } else if(newVal.color.lustre == 2) {
                    this.spot_light.intensity = 0.3
                } else if(newVal.color.lustre == 3) {
                    this.spot_light.intensity = 0.35
                } else {
                    this.spot_light.intensity = 0.3
                }
                this.u = newVal.color.x ? 180.62 / newVal.color.x : 1
                this.v = newVal.color.y ? 180.62 / newVal.color.y : 1
                tools3d.cache_external_image(newVal.color.color_value + '?x-oss-process=image/resize,w_1024,limit_0', (new_img) => {
                    this.main_fabric_texture.image = new_img;
                    this.main_fabric_texture.needsUpdate = true;
                    this.main_fabric_texture.wrapS = this.main_fabric_texture.wrapT = THREE.RepeatWrapping;
                    this.main_fabric_texture.repeat.set(this.u, this.v);
                    this.main_fabric_texture.flipY = false;
                    this.render();
                })
            },
        },
        computed: {
            ...mapState({
                category: (state) => state.mtm.picked_category,
                main_fabric_list: (state) => state.mtm.picked_category.hasOwnProperty('fabric') ? state.mtm.picked_category.fabric : Array.of(),
                original_part_list: (state) => state.mtm.picked_category.hasOwnProperty('part') ? state.mtm.picked_category.part : Array.of(),
                base_part_list: (state) => state.mtm.picked_category.hasOwnProperty('base') ? state.mtm.picked_category.base : Array.of(),
                ratio: (state) => state.mtm.picked_category.ratio,
                current_fabric: (state) => state.mtm.form_data.fabric_list.material,
                current_color: (state) => state.mtm.form_data.fabric_list.color
            }),
            // 初始化默认选中每个部件第一个选项
            first3dobj_list() {
                let result = {}
                this.original_part_list.forEach((item) => {
                    if(this.model3dList[item.category_key] && this.model3dList[item.category_key].model_path) {
                        this.current3d_obj[item.category_key] = result[item.category_key] = this.model3dList[item.category_key]
                    } else if(item.option_list[0].model_path) {
                        this.current3d_obj[item.category_key] = result[item.category_key] = {
                            option_name: item.option_list[0].part_name_cn,
                            model_path: item.option_list[0].model_path,
                            transparent: false,
                            is_base: false
                        }
                    }
                });
                this.base_part_list.forEach((item) => {
                    result[item.name] = {
                        option_name: item.name,
                        model_path: item.model_path,
                        transparent: true,
                        is_base: true
                    }
                });
                return result
            },
            part_custom_material() {
                let result = {}
                this.original_part_list.forEach((item) => {
                    result[item.category_key] = {}
                    if(item.texture_list.length > 0) {
                        result[item.category_key].is_custom = true
                        let color_value = item.texture_list[0].color_value
                        result[item.category_key].transparent = !!color_value.includes('.png')
                        if(color_value.includes('http')) {
                            result[item.category_key].texture = new THREE.Texture()
                            tools3d.cache_external_image(item.texture_list[0].color_value + '?x-oss-process=image/resize,w_1024,limit_0', (new_img) => {
                                result[item.category_key].texture.image = new_img;
                                result[item.category_key].texture.needsUpdate = true;
                                result[item.category_key].texture.wrapS = result[item.category_key].texture.wrapT = THREE.RepeatWrapping;
                                result[item.category_key].texture.repeat.set(this.u, this.v);
                                result[item.category_key].texture.flipY = false;
                                this.render();
                            })
                        } else {
                            result[item.category_key].texture = Number.parseInt("0x" + color_value.slice(1))
                        }

                    } else {
                        result[item.category_key].is_custom = false
                    }
                });
                this.base_part_list.forEach((item) => {
                    result[item.name] = {}
                    if(item.image) {
                        result[item.name].is_custom = true
                        result[item.name].texture = new THREE.Texture()
                        result[item.name].transparent = !!item.image.includes('.png')
                        tools3d.cache_external_image(item.image + '?x-oss-process=image/resize,w_1024,limit_0', (new_img) => {
                            result[item.name].texture.image = new_img;
                            result[item.name].texture.needsUpdate = true;
                            result[item.name].texture.wrapS = result[item.name].texture.wrapT = THREE.RepeatWrapping;
                            result[item.name].texture.repeat.set(this.u, this.v);
                            result[item.name].texture.flipY = false;
                            // this.render();
                        })
                    } else {
                        result[item.name].is_custom = false
                    }
                });
                return result
            },
            first_main_fabric_image() {
                return this.mainFabricImage.color.color_value || this.main_fabric_list[0].color_list[0].color_value
            }
        },
        methods: {
            view_fabric(src) {
                this.$viewerApi({
                    options: {
                        title: false,
                        navbar: false,
                        movable: false,
                    },
                    images: [src],
                })
                this.is_show_fabric_modal = true
            },
            render(is_store = true) {
                this.camera.lookAt(this.model_center);
                this.directional_light.lookAt(this.scene.position);
                this.spot_light.lookAt(this.scene.position);
                this.renderer.render(this.scene, this.camera);
                if(is_store) {
                    this.$store.commit('mtm/update_effect_picture', this.renderer.domElement.toDataURL())
                }
            },
            wheel() {
                event.stopPropagation();
                event.preventDefault();
                if (this.camera.fov + event.deltaY * C.STEP_WHEEL_FOV < 1 || this.camera.fov + event.deltaY * C.STEP_WHEEL_FOV > 80) {
                    this.$Message.destroy();
                    this.$Message.warning('已缩放到最大值')
                    return
                }
                this.camera.fov += event.deltaY * C.STEP_WHEEL_FOV;
                this.camera.updateProjectionMatrix();
                this.render(false);
            },
            mousedown() {
                if (event.button == 0) {
                    this.drag = true;
                }
            },
            mouseup() {
                this.drag = false
            },
            mousemove() {
                event.preventDefault()
                if (this.drag) {
                    let movementX = event.movementX;
                    let movementY = event.movementY;
                    let speedX = 7;
                    let speedY = 300;
                    if (movementX != undefined) { // 控制旋转
                        if (movementX > 0) this.clothes_model.rotation.y += speedX * Math.PI / 180;
                        if (movementX < 0) this.clothes_model.rotation.y -= speedX * Math.PI / 180;
                    }
                    if (movementY != undefined) { // 控制上下平移
                        if (movementY > 0) this.clothes_model.position.y -= speedY * Math.PI / 180;
                        if (movementY < 0) this.clothes_model.position.y += speedY * Math.PI / 180;
                    }
                    this.render(false);
                }
            },
            enlarge() {
                if(this.camera.fov - C.STEP_CLICK_FOV <= 0) {
                    this.$Message.destroy();
                    this.$Message.warning('已放大到最大值')
                    return
                }
                this.camera.fov -= C.STEP_CLICK_FOV
                this.camera.updateProjectionMatrix();
                this.render(false)
            },
            //刷新空界面
            refresh() {
                this.scene.remove(this.clothes_model);
                this.dispose(this.clothes_model);
                THREE.Cache.clear();
                this.clothes_model = new THREE.Group;
                this.camera.fov = C.CAMERA_FOV;
                this.camera.position.set(0, 500, 1300);
                this.camera.rotation.x = -.2;
                this.clothes_model.position.set(0, 0, 0);
                this.camera.updateProjectionMatrix();
                this.scene.add(this.clothes_model);
                this.render();
            },
            dispose(obj){
                if (obj instanceof THREE.Group) {
                    obj.traverse(function (child) {
                        if (child instanceof THREE.Mesh){
                            child.geometry.dispose();
                            child.material.dispose();
                        }
                    });
                } else if (obj instanceof THREE.Mesh){
                    obj.geometry.dispose();
                    obj.material.dispose();
                }
            }
        },
        created() {
            this.$Spin.show();
        },
        mounted() {
            if(!this.category.is_enable3d) {
                this.$Spin.hide()
                return
            }
            console.log("3D renders~")
            // Renderer渲染器初始化
            this.renderer.setSize( 800, 800);
            this.renderer.setPixelRatio( window.devicePixelRatio );
            this.renderer.setClearColor(0xF3F4F5, 1);
            this.renderer.domElement.style.width = '41.66vw'
            this.renderer.domElement.style.height = '41.66vw'
            this.$refs.renderer3d.appendChild(this.renderer.domElement);
            // 相机初始化
            this.camera.position.set(0, 500, 1300);
            this.camera.rotation.x = -0.2;
            this.scene.position.set(0, 0, 0);
            this.scene.add(this.clothes_model);
            this.scene.add(new THREE.AmbientLight(0xaaaaaa));
            this.directional_light.position.set(700, 1490, 600);
            this.scene.add(this.directional_light);
            this.spot_light.name = 'Spot Light';
            this.spot_light.position.set(500, 2100, 1500);
            this.spot_light.penumbra = 1;
            this.spot_light.decay = 1;
            this.spot_light.angle = Math.PI / 4;
            this.scene.add(this.spot_light);

            // var axesHelper = new THREE.AxisHelper( 5000 );
            // this.scene.add( axesHelper );
            // var helper = new THREE.CameraHelper( this.camera );
            // this.scene.add( helper );


            this.render()

            // 事件侦听 Start
            this.renderer.domElement.addEventListener('wheel',  this.wheel, false);
            this.renderer.domElement.addEventListener('mousedown', this.mousedown, false);
            this.renderer.domElement.addEventListener('mouseup',  this.mouseup, false);
            this.renderer.domElement.addEventListener('mousemove',  this.mousemove, false);
            // 事件侦听 End

            // 主材质加载
            tools3d.cache_external_image(this.first_main_fabric_image + '?x-oss-process=image/resize,w_1024,limit_0', (new_img) => {
                this.main_fabric_texture.image = new_img;
                this.main_fabric_texture.needsUpdate = true;
                this.main_fabric_texture.wrapS = this.main_fabric_texture.wrapT = THREE.RepeatWrapping;
                this.main_fabric_texture.repeat.set(this.current_color.x ? 180.62 / this.current_color.x : 1, this.current_color.y ? 180.62 / this.current_color.y : 1);
                this.render();
            })

            // 利用Promise处理各种异步回调时的判断
            new Promise((resolve, reject) => {
                console.log("初始部件加载")
                // 初始渲染
                let complete = 0;
                for(let key in this.first3dobj_list) {
                    this.gltf_loader.load(this.first3dobj_list[key].model_path, (object) => {
                        // 基础件使用自带图案
                        if(!this.first3dobj_list[key].is_base) {
                            object.scene.traverse((child) => {
                                if(child instanceof THREE.Mesh) {
                                    let material = new THREE.MeshPhongMaterial({
                                        shininess: 0,
                                        side: THREE.DoubleSide,
                                        map: this.main_fabric_texture,
                                    });
                                    if(typeof this.part_custom_material[key].texture === 'number') {
                                        material = new THREE.MeshPhongMaterial({
                                            shininess: 0,
                                            side: THREE.DoubleSide,
                                            color: this.part_custom_material[key].texture // 颜色只能在生成时候设置？？？
                                        });
                                    } else if(typeof this.part_custom_material[key].texture === 'object') {
                                        // this.part_custom_material[key].texture.rotation = Math.PI
                                        material.map = this.part_custom_material[key].texture
                                        material.map.needsUpdate = true
                                        material.transparent = this.part_custom_material[key].transparent
                                    }
                                    child.material = material;
                                }
                            })
                        }

                        // object.position.y = -150
                        // object.scale.x = object.scale.y = object.scale.z = this.ratio;
                        object.scene.name = this.first3dobj_list[key].option_name
                        this.clothes_model.add(object.scene)
                        this.render();

                        this.map3d_obj.set(key, new Map([
                            [this.first3dobj_list[key].option_name, object]
                        ]))
                        complete++;
                        if(complete === Object.keys(this.first3dobj_list).length) {
                            resolve("结束")
                        }
                    })
                }
            }).then(() => {
                console.log("所有模型预加载")
                // 所有模型预加载，费流量
                this.original_part_list.forEach((item) => {
                    let current_part = this.map3d_obj.get(item.category_key)
                    item.option_list.forEach((option_item) => {
                        let key = item.category_key
                        if(!current_part.get(option_item.part_name_cn)) {
                            this.gltf_loader.load(option_item.model_path, (object) => {
                                object.scene.traverse((child) => {
                                    if (child instanceof THREE.Mesh) {
                                        let material = new THREE.MeshPhongMaterial({
                                            shininess: 0,
                                            side: THREE.DoubleSide,
                                            map: this.main_fabric_texture
                                        });
                                        if (typeof this.part_custom_material[key].texture === 'number') {
                                            material = new THREE.MeshPhongMaterial({
                                                shininess: 0,
                                                side: THREE.DoubleSide,
                                                color: this.part_custom_material[key].texture // 颜色只能在生成时候设置？？？
                                            });
                                        } else if (typeof this.part_custom_material[key].texture === 'object') {
                                            material.map = this.part_custom_material[key].texture
                                            material.map.needsUpdate = true
                                        }
                                        child.material = material;
                                    }
                                })
                                // object.position.y = -0.9
                                // object.scale.x = object.scale.y = object.scale.z = this.ratio;
                                object.scene.name = option_item.part_name_cn
                                object.scene.visible = false
                                this.clothes_model.add(object.scene)
                                current_part.set(option_item.part_name_cn, object)
                            })
                        }
                    })
                });
            }).finally(() => {
                let box = new THREE.Box3().setFromObject( this.clothes_model );
                // 计算模型XYZ维度和欧拉长度
                const size = box.getSize(new THREE.Vector3()).length();
                // 计算模型中心点
                this.model_center = box.getCenter(new THREE.Vector3());
                if(size > 1000) {
                    this.camera.fov = 50
                    this.camera.updateProjectionMatrix();
                }
                this.$Spin.hide();
                this.render(true)
            })
        }
    }
</script>

<style scoped lang="scss">

    .tools-panel {
        position: absolute;
        top: 20px;
        right: 320px;
        width: 80px;
        .btn-wrap{
            display: flex;
            flex-wrap: wrap;
            justify-content: center;
            width: 80px;
            margin-bottom: 20px;
            cursor: pointer;
            .btn-tools {
                width: 48px;
                height: 48px;
            }
            .text {
                width: 80px;
                margin-top: 5px;
                color: #333333;
                font-size: 13px;
                text-align: center;
            }
        }

    }
</style>
